export default {
  home: {
    title: 'Collection de Jeux HTML5',
    subtitle: 'Jouez instantanément dans votre navigateur. Pas de téléchargement, juste du plaisir !',
    browseGames: 'Parcourir les Jeux',
    popularGames: 'Jeux Populaires',
    newGames: 'Nouveaux Jeux',
    recommendedGames: 'Jeux Recommandés',
    recentlyPlayed: 'Récemment Joués',
    popular: 'Populaire',
    genres: {
      casual: 'Casual',
      puzzle: 'Puzzle',
      racing: 'Course',
      racing_driving: 'Course et Conduite',
      shooter: 'Tir',
      simulation: 'Simulation',
      strategy: 'Stratégie',
      sports: 'Sports',
      agility: 'Agilité',
      battle: 'Combat',
      care: 'Soins',
      cooking: 'Cuisine',
      football: 'Football',
      '.IO': 'Combats en Temps Réel',
      merge: 'Fusion',
      all: 'Tous',
      other: 'Autres',
      dressup: 'Habillage',
      adventure: 'Aventure',
      mahjong_connect: 'Mahjong et Connexion',
      jigsaw: 'Puzzle',
      basketball: 'Basketball',
      quiz: 'Quiz',
      bubble_shooter: 'Tir de Bulles',
      match3: 'Match-3',
      boardgames: 'Jeux de Société',
      educational: 'Éducatif',
      cards: 'Cartes'
    }
  },
  games: {
    playNow: 'Jouer Maintenant',
    relatedGames: 'Jeux Similaires',
    instructions: 'Instructions du Jeu',
    controlsTitle: 'Contrôles du Jeu',
    addToFavorites: 'Ajouter aux Favoris',
    removeFromFavorites: 'Retirer des Favoris',
    share: 'Partager le Jeu',
    reportIssue: 'Signaler un Problème',
    fullscreen: 'Mode Plein Écran',
    exitFullscreen: 'Quitter le Plein Écran'
  },
  categories: {
    title: 'Catégories de Jeux',
    subtitle: 'Explorez nos riches catégories de jeux',
    allCategories: 'Toutes les Catégories',
    gamesInCategory: '{count} Jeux',
    categoryDescription: 'Ici, vous pouvez trouver tous les jeux de la catégorie {category}. Choisissez parmi différents styles et commencez à jouer immédiatement !',
    pageTitle: 'Catégories de Jeux',
    pageDescription: 'Explorez nos diverses catégories de jeux et trouvez votre type de jeu préféré',
    allGames: 'Tous les Jeux',
    gamesFound: '{count} Jeux Trouvés',
    other: 'Autres',
    taggedGames: 'Jeux {tag}',
    noGamesInCategory: 'Aucun Jeu dans Cette Catégorie',
    loadMore: 'Charger Plus',
    otherGames: 'Autres Jeux',
    seoTitle: 'GoGameVault - Catégories de Jeux | Jeux HTML5 Gratuits en Ligne',
    seoDescription: 'Explorez diverses catégories de jeux sur GoGameVault, y compris action, puzzle, arcade, sports, course et plus, pour trouver votre type de jeu préféré.',
    seoKeywords: 'catégories de jeux,jeux en ligne,jeux gratuits,jeux HTML5,jeux de navigateur',
    descriptions: {
      'Casual': 'Jeux casual simples et faciles adaptés aux joueurs de tous âges, profitez du jeu sans pression.',
      'Puzzle': 'Jeux de réflexion qui apportent satisfaction à travers la résolution d\'énigmes et de défis mentaux.',
      'Racing & Driving': 'Vivez la vitesse et l\'excitation dans des jeux de course et de conduite palpitants.',
      'Shooter': 'Testez votre précision de tir et votre temps de réaction, battez tous les ennemis.',
      'Simulation': 'De la gestion urbaine au pilotage d\'avions, simulez diverses expériences du monde réel.',
      'Strategy': 'Jeux de stratégie nécessitant une planification minutieuse et une réflexion tactique.',
      'Sports': 'Jeux de sport simulant divers événements athlétiques, montrez votre talent sportif.',
      'Agility': 'Jeux d\'agilité testant la vitesse de réaction et la coordination, répondez rapidement aux défis.',
      'Battle': 'Jeux de combat avec une compétition intense, gagnez grâce à l\'habileté et la stratégie.',
      'Care': 'Jeux de soin offrant la joie de s\'occuper d\'animaux, de patients ou d\'autres personnages.',
      'Cooking': 'Montrez vos talents culinaires, créez des plats délicieux et gérez des restaurants.',
      'Football': 'Vivez le sport le plus populaire au monde, montrez vos compétences et tactiques.',
      '.IO': 'Jeux de combat en temps réel, jeux compétitifs multijoueurs en ligne pour rivaliser et progresser.',
      'Merge': 'Jeux de fusion où vous créez de nouveaux objets en combinant des éléments identiques.',
      'other': 'Expériences de jeu uniques qui ne rentrent pas dans les catégories habituelles.',
      'generic': 'Explorez divers jeux {tag} et trouvez vos favoris.'
    }
  },
  search: {
    title: 'Résultats de Recherche',
    placeholder: 'Rechercher des jeux...',
    resultsFor: 'Résultats de recherche pour "{query}"',
    noResults: 'Aucun Jeu Trouvé',
    noResultsMessage: 'Aucun jeu trouvé en rapport avec "{query}"',
    tryAgain: 'Veuillez essayer avec des mots-clés différents ou parcourir nos catégories.',
    returnToHomepage: 'Retour à la Page d\'Accueil',
    foundResults: 'Trouvé {count} jeux',
    seoTitle: 'Rechercher "{query}" - GoGameVault | Jeux HTML5 Gratuits en Ligne',
    seoDescription: 'Recherchez des jeux HTML5 gratuits en ligne liés à "{query}" sur GoGameVault. Trouvez divers jeux amusants, sans téléchargement requis, jouez directement dans votre navigateur.'
  },
  gameDetail: {
    title: 'Détails du Jeu',
    gameTitle: 'Titre du Jeu',
    genres: 'Genres du Jeu',
    tags: 'Tags',
    gameDescription: 'Description du Jeu',
    controlsAndInstructions: 'Contrôles et Instructions',
    similarGames: 'Jeux Similaires',
    new: 'Nouveau Jeu',
    playAmazingGame: 'Jouez à ce jeu incroyable maintenant',
    noSimilarGames: 'Pas de jeux similaires',
    gameNotFound: 'Jeu Non Trouvé',
    gameNotExistOrRemoved: 'Ce jeu n\'existe pas ou a été supprimé',
    backToHome: 'Retour à la Page d\'Accueil',
    seoTitle: '{title} - Jouez Gratuitement en Ligne | GoGameVault',
    seoTitleNotFound: 'Jeu Non Trouvé | GoGameVault',
    seoKeywords: '{title}, jeux en ligne, jeux gratuits, {tags}, jeux HTML5',
    gameUnavailable: 'Jeu Temporairement Indisponible',
    tryAgainLater: 'Veuillez réessayer plus tard',
    share: 'Partager',
    openInNewTab: 'Ouvrir dans un Nouvel Onglet'
  },
  about: {
    title: 'À Propos de Nous',
    aboutUs: 'À Propos de Nous',
    ourMission: 'Notre Mission',
    contactUs: 'Contactez-Nous',
    privacyPolicy: 'Politique de Confidentialité',
    termsOfService: 'Conditions d\'Utilisation',
    feedbackTitle: 'Commentaires',
    feedbackText: 'Nous travaillons constamment à améliorer notre site web. Si vous avez des suggestions ou trouvez des problèmes, veuillez nous en informer !',
    missionTitle: 'Notre Mission',
    missionText1: 'GoGameVault est dédié à offrir aux utilisateurs la meilleure expérience de jeu en ligne gratuite. Nous sélectionnons soigneusement des jeux HTML5 amusants et de haute qualité que vous pouvez apprécier sans téléchargement.',
    missionText2: 'Notre objectif est de créer une plateforme de jeu conviviale où les joueurs peuvent facilement trouver et jouer aux jeux qu\'ils aiment.',
    feature1Title: 'Jeux Sélectionnés',
    feature1Text: 'Nous sélectionnons soigneusement chaque jeu pour assurer des graphismes de haute qualité et un gameplay fluide.',
    feature2Title: 'Jouez N\'importe Quand, N\'importe Où',
    feature2Text: 'Tous les jeux fonctionnent directement dans votre navigateur sans besoin de télécharger ou d\'installer de logiciel supplémentaire.',
    feature3Title: 'Complètement Gratuit',
    feature3Text: 'Tous nos jeux sont complètement gratuits, sans frais cachés ni achats intégrés.',
    contactTitle: 'Contactez-Nous',
    contactText: 'Si vous avez des questions, des suggestions ou des commentaires, n\'hésitez pas à nous contacter. Nous valorisons les opinions des utilisateurs et nous nous engageons à améliorer continuellement nos services.',
    seoTitle: 'GoGameVault - À Propos de Nous | Jeux HTML5 Gratuits en Ligne',
    seoDescription: 'GoGameVault est une plateforme de jeu HTML5 en ligne gratuite offrant des jeux sélectionnés que vous pouvez jouer n\'importe où sans téléchargement. Découvrez notre mission et nos fonctionnalités.',
    seoKeywords: 'jeux en ligne,jeux gratuits,jeux HTML5,jeux de navigateur,sans téléchargement'
  },
  notFound: {
    title: 'Page Non Trouvée',
    message: 'Désolé, la page que vous avez visitée n\'existe pas ou a été supprimée. Permettez-nous de vous remettre sur la bonne voie !',
    returnHome: 'Retour à la Page d\'Accueil',
    goBack: 'Retour',
    popularGames: 'Recommandations de Jeux Populaires',
    popularGamesDesc: 'Explorez ces jeux en vedette pour commencer votre voyage de jeu',
    seoTitle: 'Page Non Trouvée - GoGameVault',
    seoDescription: 'Désolé, la page que vous avez visitée n\'existe pas sur GoGameVault. Parcourez nos jeux populaires pour une nouvelle expérience de jeu.'
  },
  categoryGames: {
    games: 'Jeux',
    gamesAvailable: '{count} Jeux Disponibles',
    noGamesFound: 'Aucun Jeu Trouvé',
    noGamesInCategory: 'Aucun Jeu dans Cette Catégorie',
    exploreCategories: 'Explorer D\'autres Catégories',
    backToCategories: 'Retour aux Catégories',
    invalidCategory: 'Catégorie Invalide',
    categoryNotExist: 'La catégorie que vous recherchez n\'existe pas.',
    browseCategories: 'Parcourir Toutes les Catégories',
    category: 'Catégorie',
    seoTitle: 'Jeux {tag} - Jouez en Ligne - GoGameVault',
    seoDescriptionWithGames: 'Parcourez et jouez gratuitement à {count} jeux {tag} en vedette. Tous les jeux peuvent être joués directement dans votre navigateur sans téléchargement requis.',
    seoDescriptionDefault: 'Parcourez et jouez gratuitement à nos jeux {tag}. Tous les jeux peuvent être joués directement dans votre navigateur sans téléchargement requis.',
    seoKeywords: 'jeux {tag},jeux en ligne gratuits,jeux de navigateur'
  }
}; 